module.exports = __webpack_public_path__ + "static/media/1a.86540e8b.png";